// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","sidebarWrap":"App_sidebarWrap__fi1ku","contentWrap":"App_contentWrap__spQzu"};